export const TIMESHEET_TABLE_CONTEXT = {
  EMPLOYEE_JOB_TAB: 'employeeJobTab'
};
